import React, { useEffect, useState } from "react";
import { useWA, useLoad, useDebounced, useSelection, PageHead, Card, Tabs, Search, Btn, StatusBadge, Toggle, BulkBar, Check, Pager, Skeleton, Empty, ErrorBox, Avatar, ago, fdt, exportCsv } from "../ui";

const TAKE = 40;

export default function Messages() {
  const { run, confirm } = useWA();
  const [status, setStatus] = useState("NEW");
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const [openId, setOpenId] = useState(null);
  const [openObj, setOpenObj] = useState(null);
  const [reply, setReply] = useState("");
  const [notify, setNotify] = useState(true);
  const [busy, setBusy] = useState(false);
  const dq = useDebounced(q);
  useEffect(() => setSkip(0), [status, dq]);
  const { data, loading, error, reload } = useLoad("contacts", { status, q: dq, take: TAKE, skip }, [status, dq, skip]);
  const items = (data && data.items) || [];
  const counts = (data && data.counts) || {};
  const S = useSelection(items);
  const m = items.find((x) => x.id === openId) || (openObj && openObj.id === openId ? openObj : null);

  useEffect(() => {
    setReply(m ? m.reply || "" : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openId]);

  const act = async (action, params, msg, ask) => {
    if (ask && !(await confirm(ask))) return;
    try {
      await run(action, params, msg);
      reload();
    } catch (e) {
      /* toast */
    }
  };

  const openMsg = (x) => {
    setOpenId(x.id);
    setOpenObj(x);
    if (x.status === "NEW") run("contactUpdate", { id: x.id, status: "SEEN" }).then(() => reload()).catch(() => null);
  };

  const sendReply = async () => {
    setBusy(true);
    await act("contactUpdate", { id: m.id, status: "REPLIED", reply, notifyUser: notify }, notify ? "जवाब save हुआ (account हो तो user को notification भी गया)" : "जवाब save हुआ");
    setBusy(false);
  };

  const mailto = m ? `mailto:${m.email}?subject=${encodeURIComponent("Re: " + (m.subject || "YCNP"))}&body=${encodeURIComponent((reply || "") + "\n\n— Team YCNP\n\n> " + m.message.split("\n").join("\n> "))}` : "";

  return (
    <div>
      <PageHead icon="fa-regular fa-envelope" title="Contact Inbox" subtitle="Contact page से आए संदेश"
        actions={<Btn icon="fa-solid fa-download" disabled={!items.length} onClick={() => exportCsv(items.map((x) => ({ name: x.name, email: x.email, subject: x.subject, message: x.message, status: x.status, reply: x.reply, date: x.createdAt })), "ycnp-messages")}>CSV</Btn>} />
      <div className="flex flex-col gap-3 mb-4">
        <Tabs tabs={[["NEW", "नए", counts.NEW || 0], ["SEEN", "देखे", counts.SEEN || 0], ["REPLIED", "जवाब दिया", counts.REPLIED || 0], ["CLOSED", "बंद", counts.CLOSED || 0], ["ALL", "सभी"]]} value={status} onChange={(v) => { setStatus(v); setOpenId(null); }} />
        <Search value={q} onChange={setQ} placeholder="नाम, email या message खोजें…" />
      </div>
      <BulkBar count={S.sel.length} onClear={S.clear}>
        <Btn size="sm" variant="ghost" className="!text-white !border-white/20" onClick={() => act("contactUpdate", { ids: S.sel, status: "SEEN" }, "Seen हो गए")}>Seen</Btn>
        <Btn size="sm" variant="ghost" className="!text-white !border-white/20" onClick={() => act("contactUpdate", { ids: S.sel, status: "CLOSED" }, "बंद हो गए")}>बंद करें</Btn>
        <Btn size="sm" variant="danger" icon="fa-regular fa-trash-can" onClick={() => act("contactDelete", { ids: S.sel }, "Delete हो गए", { title: `${S.sel.length} messages delete करें?`, danger: true })}>Delete</Btn>
      </BulkBar>
      <ErrorBox msg={error} retry={reload} />
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,420px)_1fr] gap-5 items-start">
        <Card pad={false}>
          {loading && !data ? <div className="p-4"><Skeleton rows={6} h={60} /></div> : !items.length ? <Empty icon="fa-regular fa-envelope-open" title="कोई message नहीं" /> : (
            <>
              <div className="flex items-center gap-3 px-4 py-2.5 border-b wa-line text-[12px] wa-muted"><Check checked={S.all} onChange={S.toggleAll} /> सब चुनें</div>
              <ul className="max-h-[70vh] overflow-y-auto wa-scroll">
                {items.map((x) => (
                  <li key={x.id} className="flex gap-3 px-4 py-3 border-b wa-line cursor-pointer" onClick={() => openMsg(x)}
                    style={openId === x.id ? { background: "color-mix(in srgb, var(--wa-accent) 10%, transparent)" } : {}}>
                    <span onClick={(e) => e.stopPropagation()} className="pt-1"><Check checked={S.has(x.id)} onChange={() => S.toggle(x.id)} /></span>
                    <Avatar name={x.name} size={34} />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <p className={"text-sm truncate flex-1 " + (x.status === "NEW" ? "font-extrabold" : "font-semibold")}>{x.name}</p>
                        <span className="text-[11px] wa-muted whitespace-nowrap">{ago(x.createdAt)}</span>
                      </div>
                      <p className="text-[12.5px] truncate">{x.subject || "(बिना subject)"}</p>
                      <p className="text-[12px] wa-muted truncate">{x.message}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
          <Pager total={data && data.total} take={TAKE} skip={skip} onChange={setSkip} />
        </Card>

        {!m ? (
          <Card className="hidden lg:block"><Empty icon="fa-regular fa-hand-pointer" title="बाईं तरफ से कोई message चुनें" /></Card>
        ) : (
          <Card>
            <div className="flex flex-wrap items-start gap-3 mb-4">
              <Avatar name={m.name} size={44} />
              <div className="flex-1 min-w-0">
                <p className="font-bold text-lg leading-tight">{m.name} <StatusBadge s={m.status} /></p>
                <p className="text-sm wa-muted">{m.email || "email नहीं दिया"} · {fdt(m.createdAt)}</p>
              </div>
              <Btn size="sm" icon="fa-solid fa-xmark" onClick={() => setOpenId(null)} aria-label="Close" />
            </div>
            {m.subject && <p className="font-semibold mb-2">{m.subject}</p>}
            <div className="rounded-2xl p-4 text-[14.5px] leading-relaxed whitespace-pre-wrap break-words" style={{ background: "color-mix(in srgb, var(--wa-ink) 4%, transparent)" }}>{m.message}</div>

            <p className="text-sm font-semibold mt-5 mb-1.5">आपका जवाब / note</p>
            <textarea rows={5} className="wa-input" value={reply} onChange={(e) => setReply(e.target.value)} placeholder="जवाब लिखें…" />
            <Toggle label="अगर इस email का account है तो वेबसाइट notification भी भेजें" checked={notify} onChange={setNotify} />
            <div className="flex flex-wrap gap-2">
              <Btn variant="primary" icon="fa-solid fa-floppy-disk" loading={busy} disabled={!reply.trim()} onClick={sendReply}>जवाब save करें</Btn>
              {m.email && <a href={mailto}><Btn icon="fa-regular fa-paper-plane">Email app से भेजें</Btn></a>}
              <Btn icon="fa-solid fa-box-archive" onClick={() => act("contactUpdate", { id: m.id, status: "CLOSED" }, "बंद हो गया")}>बंद करें</Btn>
              <Btn className="!text-rose-600 ml-auto" icon="fa-regular fa-trash-can" onClick={() => act("contactDelete", { id: m.id }, "Delete हो गया", { title: "यह message delete करें?", danger: true }).then(() => setOpenId(null))}>Delete</Btn>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}
